import { Box } from '@mui/material';
import { memo } from 'react';

import { Settings } from '../../../components/Settings/Settings';
import { SettingsHeader } from './SettingsHeader';

export const SettingsPage = memo(() => {
    return (
        <Box display="flex" flexDirection="column" alignItems="center" width="100%" height="100%" overflow="hidden">
            <SettingsHeader />
            <Settings />
        </Box>
    );
});
